module.exports = __webpack_public_path__ + "img/wine-glass-empty.846f84c3.svg";